import { Injectable, Param } from "@nestjs/common";
import { Repository,Raw,getConnection, getManager } from "typeorm";
import { InjectRepository } from "@nestjs/typeorm";
import { fgDamagesEntity } from "./dto/fg-damages-entity";
import { FgDamagesAdapter } from "./dto/fg-damages-adapter";
import { FgDamagesDto } from "./dto/fg-damages-dto";
import { CommonResponse } from "@gtpl/shared-models/masters";
import appSettings from "apps/services/config";
import { FgIdRequest, unitIdRequest } from "./dto/plant-request";
import { FgDamagesResponseModel } from "@gtpl/shared-models/warehouse-management";

@Injectable()

export class FgDmagesService{
    constructor(@InjectRepository(fgDamagesEntity)
    private fgdamagesrepo:Repository<fgDamagesEntity>,
    private fgadapter:FgDamagesAdapter
    ){}
    async createFgDamgesReason(fgDamagesDto: FgDamagesDto, isUpdate: boolean): Promise<CommonResponse> {
        try {
          const convertedfgdamgesEntity: fgDamagesEntity = this.fgadapter.convertDtoToEntity(fgDamagesDto,isUpdate);
          const savedFgdamgesEntity: fgDamagesEntity = await this.fgdamagesrepo.save(
            convertedfgdamgesEntity
          );
          const savedFgDamagesDto: FgDamagesDto = this.fgadapter.convertEntityToDto(convertedfgdamgesEntity);
          if (savedFgDamagesDto) {
            const response = new CommonResponse(true,1,isUpdate? 'fgdamages Updated Successfully': 'fgdamages Created Successfully')
            return response
          } else {
            throw new CommonResponse(false,11106,'fgdamages saved but issue while transforming into DTO');
          }
        } catch (error) {
          return error;
        }
      }  
      async getLocationforDamages(req:unitIdRequest): Promise<CommonResponse>{
        try{
          const manager= getManager();
          const query = 'SELECT s.`location` AS locationId,r.rack_code AS rackCode FROM `erpx_dev_warehouse`.`stock` s LEFT JOIN `erpx_dev_masters`.`rack_position` r ON r.`rack_position_id`= s.location  WHERE s.STATUS="StockIn" AND s.state="Stock" AND s.unit_id='+req.unitId+' GROUP BY s.location ';
          const result =await manager.query(query)
          if (result) {
            return new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
          } else {
            return new CommonResponse(false, 1111, "Error occure")
      
          }
      
        }catch(err){
          return err;
        }
      
      }
      async getsaleorderagainstlocation(req:unitIdRequest): Promise<CommonResponse>{
        try{
          const manager= getManager();
          const query = ' SELECT CONCAT(sd.po_number,"-",sk.variant_code) AS product,s.unit_id,sd.po_number AS poNumber,variant_code AS variantCode,s.stock_id,s.varient_id AS varientId,s.location,s.sale_order_id AS saleOrderId,s.sale_order_item_id AS saleOrderItemId FROM `erpx_dev_warehouse`.stock s LEFT JOIN `erpx_dev_sales`.`so_invoice_details` sd ON sd.sale_order_id=s.sale_order_id LEFT JOIN `erpx_dev_masters`.`sku_codes` sk ON sk.sku_code_id=s.varient_id WHERE s.unit_id='+req.unitId+' AND s.location='+req.locationId+'';
          const result =await manager.query(query)
          if (result) {
            return new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
          } else {
            return new CommonResponse(false, 1111, "Error occure")
      
          }
      
        }catch(err){
          return err;
        }
      
      }
      async getAllfgDamagesData(req:unitIdRequest): Promise<CommonResponse>{
        try{
          const manager= getManager();
          const query = 'SELECT f.version_flag as versionFlag,ed.employee_name AS employeeName,f.created_at,CONCAT(r.rack_code,"-",si.po_number,"-",mb.brand_name,"-",sk.variant_code,"-",s.product_category,"-",p.packing_method_name) AS product,p.packing_method_name AS packingMethodName,sk.variant_code AS variantCode,mb.brand_name,r.rack_code AS rackCode,si.po_number AS poNumber,f.fg_damage_id AS fgDamageId,f.location_id AS locationId,f.stock_id  AS stockId,f.sale_order_id AS saleOrderId,f.sale_order_item_id AS saleOrderItemId,f.damage_level  AS damageLevel,f.damage_type AS damageType,f.no_of_cartons noOfCartons,damage_by AS damageBy,f.is_active AS isActive,damage_reason AS damageReason,f.created_at  FROM `erpx_dev_warehouse`.`fg_damages` f LEFT JOIN `erpx_dev_sales`.`so_invoice_details` si ON f.sale_order_id=si.sale_order_id LEFT JOIN `erpx_dev_masters`.`rack_position` r ON f.location_id =r.rack_position_id LEFT JOIN `erpx_dev_warehouse`.`stock` s ON f.stock_id=s.stock_id  AND f.sale_order_id=s.sale_order_id AND f.sale_order_item_id=s.sale_order_item_id AND f.location_id=s.location LEFT JOIN `erpx_dev_masters`.`master_brands` mb ON mb.master_brand_id = s.brand_id   LEFT JOIN `erpx_dev_masters`.`packing_methods` p ON p.packing_method_id=s.pack_style_id LEFT JOIN `erpx_dev_masters`.`sku_codes` sk ON sk.sku_code_id=s.varient_id LEFT join '+appSettings.masters_db+'.employee_details ed ON ed.employee_id=f.damage_by WHERE s.STATUS="StockIn" AND s.state="Stock" AND s.unit_id='+req.unitId+' ORDER BY f.created_at DESC'; 
          const result =await manager.query(query)
          if (result) {
            return new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
          } else {
            return new CommonResponse(false, 1111, "Error occure")
      
          }
      
        }catch(err){
          return err;
        }
      
      }
   
        async getallLocationSaleorderandProduct(req:unitIdRequest): Promise<CommonResponse>{
          try{
            const manager= getManager();
            const query = 'SELECT  CONCAT(r.rack_code,"-",si.po_number,"-",mb.brand_name,"-",sk.variant_code,"-",product_category,"-",p.packing_method_name) AS product,si.po_number AS poNumber,r.rack_code AS rackCode,mb.brand_name AS brandName,p.packing_method_name AS packingMethodName,sk.variant_code AS variantCode,s.stock_id AS stockId,s.sale_order_id AS saleOrderId,s.sale_order_item_id AS saleOrderItemId,s.total_cartons AS totalCartons,product_category AS productCategory,s.brand_id brandId,s.varient_id,s.pack_style_id AS packStyleId,s.location AS locationId FROM `erpx_dev_warehouse`.`stock`  s LEFT JOIN `erpx_dev_sales`.`so_invoice_details` si ON s.sale_order_id=si.sale_order_id LEFT JOIN `erpx_dev_masters`.`rack_position` r ON r.rack_position_id = s.location LEFT JOIN `erpx_dev_masters`.`master_brands` mb ON mb.master_brand_id = s.brand_id LEFT JOIN `erpx_dev_masters`.`packing_methods` p ON p.packing_method_id=s.pack_style_id LEFT JOIN `erpx_dev_masters`.`sku_codes` sk ON sk.sku_code_id=s.varient_id WHERE s.STATUS="StockIn" AND s.state="Stock" AND s.unit_id='+req.unitId+' GROUP BY s.sale_order_id,s.sale_order_item_id,s.location,s.pack_style_id,s.product_category';
            const result =await manager.query(query)
            if (result) {
              return new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
            } else {
              return new CommonResponse(false, 1111, "Error occure")
        
            }
        
          }catch(err){
            return err;
          }
        
        }
        async getdamagebyId(id: number): Promise<fgDamagesEntity> {
          const Response = await this.fgdamagesrepo.findOne({
          where: {fgDamageId: id},
          });
          console.log(Response)
          if (Response) {
            return Response
            ;
          } else {
          return null;
          }
      }
    
      async activateOrDeactivateDamges(Req: FgIdRequest): Promise<FgDamagesResponseModel> {
          try {
              const fgdamagesexist = await this.getdamagebyId(Req.fgDamageId);
              if (fgdamagesexist) {
                  if (Req.versionFlag !== fgdamagesexist.versionFlag) {
                      throw new FgDamagesResponseModel(false,10113, 'Someone updated the current FgDamages information.Refresh and try again');
                  } else {
                      
                          const fgdamagesstatus =  await this.fgdamagesrepo.update(
                              { fgDamageId: Req.fgDamageId },
                              { isActive: Req.isActive,updatedUser: Req.updatedUser });
                         
                          if (fgdamagesexist.isActive) {
                              if (fgdamagesstatus.affected) {
                                  const fgresponse: FgDamagesResponseModel = new FgDamagesResponseModel(true, 10115, 'FgDamages is de-activated successfully');
                                  return fgresponse;
                              } else {
                                  throw new FgDamagesResponseModel(false,10111, 'FgDamages is already deactivated');
                              }
                          } else {
                              if (fgdamagesstatus.affected) {
                                  const DownTimeReasonResponse: FgDamagesResponseModel = new FgDamagesResponseModel(true, 10114, 'FgDamages is activated successfully');
                                  return DownTimeReasonResponse;
                              } else {
                                  throw new FgDamagesResponseModel(false,10112, 'FgDamages is already  activated');
                              }
                          }
                      // }
                  }
              } else {
                  throw new FgDamagesResponseModel(false,99998, 'No Records Found');
              }
          } catch (err) {
              return err;
          }
      }

}